<svelte:element
  this={fields.buttonFunction ? 'div' : 'a'}
  href={fields.buttonFunction ? null : fields.buttonLink}
  class="jolojo-cms-button" bind:this={button}
  target={fields.buttonFunction ? null : fields?.newTab ? '_blank' : '_self'}
>
  {#if fields.selectedButtonClass?.startsWith('jolojo-special-button')}
    <button class={fields.selectedButtonClass} style="background-color: {fields.backgroundColour}; color: {fields.textColour}">
      {fields.buttonText}
    </button>
  {:else}
    <button class={fields.selectedButtonClass}>
      {fields.buttonText}
    </button>
  {/if}
</svelte:element>

<script>
  import { onMount } from 'svelte'

  export let fields = {}

  let button = null

  function previousPage () {
    window.history.back()
  }

  onMount(() => {
    if (fields.buttonFunction) {
      button.addEventListener('click', () => {
        switch (fields.buttonFunction) {
          case 'previousPage':
            previousPage()

            break

          case 'custom':
            if (fields.customFunction) {
              // eslint-disable-next-line no-new-func
              new Function(fields.customFunction)()
            }

            break
        }
      })
    }
  })

</script>

<style lang="scss">.primary {
  background: #3b82f6;
  color: white;
}

.secondary {
  background: #6b7280;
  color: white;
}

.success {
  background: #28a744;
  color: white;
}

.danger {
  background: #ef4444;
  color: white;
}

.warning {
  background: #f59e0b;
  color: #111827;
}

.light {
  background: #f3f4f6;
  color: #111827;
}

.dark {
  background: #111827;
  color: white;
}

.outlined {
  background: #f3f4f6;
  color: #111827;
  outline: 1px solid #111827;
}

.jolojo-special-button.cta-1 {
  cursor: pointer;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #de0471;
  color: white;
  transition: 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  display: flex;
  gap: 10px;
}
.jolojo-special-button.cta-1::after {
  content: ">";
}
.jolojo-special-button.cta-1:hover {
  gap: 20px;
}

.jolojo-button {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}
.jolojo-button:hover {
  filter: brightness(0.8);
}

.jolojo-cms-button {
  color: inherit;
  text-decoration: none;
  width: fit-content;
  display: inline-block;
}
.jolojo-cms-button:hover {
  text-decoration: none;
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>